jQuery(document).ready( function($) {
    
    // New Events 
    var   debug = false;
    var   $body = $(document.body);
    
    // Phone and Text Clicks: Contact
    $('a[href^="tel:"], a[href^="sms:"]').click(function() { 
        if(debug == true) { 
            console.log("Twitter event - Contact, tracked");
        } else { 
            twttr.conversion.trackPid('o2w72', { tw_sale_amount: 0, tw_order_quantity: 0 });
        }
    });

    // Contact Submissions: Contact
    var contactForm = $('#gform_1');
    contactForm.submit( function(event) {
        event.preventDefault();

        var form = this;
        
        if(debug == true) { 
            console.log("Twitter event - Contact, tracked");
        
        } else { 
            twttr.conversion.trackPid('o2w72', { tw_sale_amount: 0, tw_order_quantity: 0 });
        }
        setTimeout( function () { 
            form.submit();
        }, 200);
    });
    
    
    // Career Submissions: SubmitApplication
    var careersForm = $('#gform_3');
    careersForm.submit( function(event) {
        event.preventDefault();

        var form = this;
        
        if(debug == true) { 
            console.log("Twitter event - SubmitApplication, tracked");
        
        } else { 
            twttr.conversion.trackPid('o2w77', { tw_sale_amount: 0, tw_order_quantity: 0 });
        }
        setTimeout( function () { 
            form.submit();
        }, 200);
    });
    
    
    // Schedule / Quote Form: Schedule / Lead
	var quoteForm = $( '#gform_2' );
	quoteForm.submit( function(event) {
        event.preventDefault();

        var form = this;
        
        if(debug == true) { 
            if( $(this).hasClass('form-schedule-service') ) {
                console.log("Twitter event - Schedule, tracked");
            } else {
                console.log("Twitter event - Lead, tracked");
            }
        
        } else { 
            if( $(this).hasClass('form-schedule-service') ) {
                twttr.conversion.trackPid('o2w76', { tw_sale_amount: 0, tw_order_quantity: 0 });
            } else {
                twttr.conversion.trackPid('o2w74', { tw_sale_amount: 0, tw_order_quantity: 0 });
            }

        }
        
        setTimeout( function () { 
            form.submit();
        }, 200);
    });
     
    
    
    // Event Continue Form: CompleteRegistration
    var continueEvent = $( '.ga-event-signup' );
    continueEvent.click( function(event) {
        event.preventDefault();

        var button = $(this);

        if(debug == true) { 
            console.log("Twitter event - CompleteRegistration, tracked");
        
        } else { 
            twttr.conversion.trackPid('o2w75', { tw_sale_amount: 0, tw_order_quantity: 0 });
        }
        
        setTimeout( function () { 
            window.open( button.attr('href') , '_blank');
        }, 200);
    });


});


